import { EditorJsOutputData } from "@dashboard/utils/richText/types";

import { PageTypeContentModule } from "./types";

export const defaultPagesContent: PageTypeContentModule = {
  pageTypeSlug: "pages",
  suggestedTitles: ["New Page", "Information", "Resources", "Updates"],
  suggestedSlugs: ["new-page", "information", "resources", "updates"],
  description: "General purpose pages",

  content: {
    time: Date.now(),
    blocks: [
      {
        type: "header",
        data: { text: "Page Title", level: 1 },
      },
      {
        type: "paragraph",
        data: {
          text: "Add your content here. This is a versatile page template that can be used for various purposes.",
        },
      },
      {
        type: "paragraph",
        data: {
          text: "Organize your content with clear headings and sections to make it easy for visitors to find what they're looking for.",
        },
      },
    ],
    version: "2.20.0",
  } as EditorJsOutputData,
};
